<template>
  <div v-if="showCtas" class="mt-5 flex-shrink-0">
    <SendForApproval v-bind="$props" :state="state" />
    <SendToContractLead v-bind="$props" :state="state" />
    <Approve v-bind="$props" :state="state" />
    <SendToCounterParty v-bind="$props" :state="state" />
    <SendBackToOriginator v-bind="$props" :state="state" />
    <Sign v-bind="$props" :state="state" @signed="signed" />
  </div>
</template>

<script>
import helpers from '@/Mixins/helpers';
import contractState from '@/Mixins/contractState';
import Approve from './Approve';
import SendForApproval from './SendForApproval';
import SendToCounterParty from './SendToCounterParty';
import SendBackToOriginator from './SendBackToOriginator';
import SendToContractLead from './SendToContractLead';
import Sign from './Sign';

export default {
  mixins: [helpers, contractState],

  components: {
    Approve,
    SendForApproval,
    SendToCounterParty,
    SendBackToOriginator,
    SendToContractLead,
    Sign,
  },

  props: {
    assetType: Object,
    asset: [String, Number],
    contract: String,
    contractLead: Object,
  },

  computed: {
    showCtas() {
      let show = false;

      // States you need have the Contract Lead role
      let showForStates = [
        'editing',
        'approved',
        'signed',
      ];

      if (showForStates.includes(this.state.state)) {
        if (this.userHasRole('contract_lead')) {
          show = true;
        }
      }

      // States you need have the Approver role
      showForStates = [
        'pending',
        'signed',
      ];

      if (showForStates.includes(this.state.state)) {
        if (this.userHasRole('approver')) {
          show = true;
        }
      }

      return show;
    },
  },

  methods: {
    signed(signature) {
      this.$emit('signed', signature);
      this.fetchAssetState(this.assetId);
    },
  },
};
</script>
